/**
 * DateInfo Molecule Component
 * Displays date range information with calendar icon
 */

'use client'

import { Calendar } from 'lucide-react'

interface DateInfoProps {
	pickupDate: string
	dropoffDate: string
}

export function DateInfo({ pickupDate, dropoffDate }: DateInfoProps) {
	return (
		<div className='flex items-center gap-2'>
			<Calendar className='w-5 h-5 text-[#09194D]' />
			<div className='flex flex-col'>
				<span
					className='font-["Bricolage_Grotesque"] text-sm font-semibold text-[#09194D]'
					suppressHydrationWarning
				>
					{pickupDate}
				</span>
				<span
					className='font-["Bricolage_Grotesque"] text-sm font-semibold text-[#09194D]'
					suppressHydrationWarning
				>
					{dropoffDate}
				</span>
			</div>
		</div>
	)
}
